/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarMeDto,
  ConcluirSafeIdDto,
  ConcluirSerproIdDto,
  DefinirAssinaturaDto,
  ErroResponse,
  ExcluirContaDto,
  IniciarSafeIdDto,
  IniciarSerproIdDto,
  IniciarSerproIdResponse,
  MeControllerEnviarAssinaturaImagemBody,
  MeControllerEnviarCertificadoA1Body,
  MeControllerEnviarCertificadoBody,
  MeControllerEnviarFotoBody,
  MeControllerEnviarLogoBody,
  MeControllerListarNotificacoesParams,
  MeResponse,
  PaginaDeNotificacoesResponse,
  RegistrarTokenPushDto,
  RemoverTokenPushDto,
  SenhaDoCertificadoDto
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getMeControllerObterUrl = () => {




  return `/v1/me`
}

/**
 * @summary Dados da sessão atual com permissoes[] expandidas
 */
export const meControllerObter = async ( options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {

  return httpClient<MeResponse>(getMeControllerObterUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeControllerObterQueryKey = () => {
    return [
    `/v1/me`
    ] as const;
    }


export const getMeControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof meControllerObter>>, TError = ErroResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeControllerObterQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerObter>>> = ({ signal }) => meControllerObter({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof meControllerObter>>>
export type MeControllerObterQueryError = ErroResponse


export function useMeControllerObter<TData = Awaited<ReturnType<typeof meControllerObter>>, TError = ErroResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerObter>>,
          TError,
          Awaited<ReturnType<typeof meControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeControllerObter<TData = Awaited<ReturnType<typeof meControllerObter>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerObter>>,
          TError,
          Awaited<ReturnType<typeof meControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeControllerObter<TData = Awaited<ReturnType<typeof meControllerObter>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Dados da sessão atual com permissoes[] expandidas
 */

export function useMeControllerObter<TData = Awaited<ReturnType<typeof meControllerObter>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeControllerObterQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMeControllerAtualizarUrl = () => {




  return `/v1/me`
}

/**
 * @summary Atualiza o próprio perfil (campos restritos)
 */
export const meControllerAtualizar = async (atualizarMeDto: AtualizarMeDto, options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {

  return httpClient<MeResponse>(getMeControllerAtualizarUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarMeDto)
  }
);}





export const getMeControllerAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerAtualizar>>, TError,{data: AtualizarMeDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerAtualizar>>, TError,{data: AtualizarMeDto}, TContext> => {

const mutationKey = ['meControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerAtualizar>>, {data: AtualizarMeDto}> = (props) => {
          const {data} = props ?? {};

          return  meControllerAtualizar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerAtualizar>>>
    export type MeControllerAtualizarMutationBody = AtualizarMeDto
    export type MeControllerAtualizarMutationError = unknown

    /**
 * @summary Atualiza o próprio perfil (campos restritos)
 */
export const useMeControllerAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerAtualizar>>, TError,{data: AtualizarMeDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerAtualizar>>,
        TError,
        {data: AtualizarMeDto},
        TContext
      > => {
      return useMutation(getMeControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getMeControllerExcluirContaUrl = () => {




  return `/v1/me`
}

/**
 * @summary Exclui a própria conta. Irreversível: encerra o acesso e as sessões.
 */
export const meControllerExcluirConta = async (excluirContaDto: ExcluirContaDto, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getMeControllerExcluirContaUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(excluirContaDto)
  }
);}





export const getMeControllerExcluirContaMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerExcluirConta>>, TError,{data: ExcluirContaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerExcluirConta>>, TError,{data: ExcluirContaDto}, TContext> => {

const mutationKey = ['meControllerExcluirConta'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerExcluirConta>>, {data: ExcluirContaDto}> = (props) => {
          const {data} = props ?? {};

          return  meControllerExcluirConta(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerExcluirContaMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerExcluirConta>>>
    export type MeControllerExcluirContaMutationBody = ExcluirContaDto
    export type MeControllerExcluirContaMutationError = ErroResponse

    /**
 * @summary Exclui a própria conta. Irreversível: encerra o acesso e as sessões.
 */
export const useMeControllerExcluirConta = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerExcluirConta>>, TError,{data: ExcluirContaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerExcluirConta>>,
        TError,
        {data: ExcluirContaDto},
        TContext
      > => {
      return useMutation(getMeControllerExcluirContaMutationOptions(options), queryClient);
    }
    export const getMeControllerEnviarLogoUrl = () => {




  return `/v1/me/logo`
}

/**
 * @summary Envia o logo impresso no cabeçalho dos documentos
 */
export const meControllerEnviarLogo = async (meControllerEnviarLogoBody: MeControllerEnviarLogoBody, options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, meControllerEnviarLogoBody.arquivo);

  return httpClient<MeResponse>(getMeControllerEnviarLogoUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getMeControllerEnviarLogoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarLogo>>, TError,{data: MeControllerEnviarLogoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarLogo>>, TError,{data: MeControllerEnviarLogoBody}, TContext> => {

const mutationKey = ['meControllerEnviarLogo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerEnviarLogo>>, {data: MeControllerEnviarLogoBody}> = (props) => {
          const {data} = props ?? {};

          return  meControllerEnviarLogo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerEnviarLogoMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerEnviarLogo>>>
    export type MeControllerEnviarLogoMutationBody = MeControllerEnviarLogoBody
    export type MeControllerEnviarLogoMutationError = ErroResponse

    /**
 * @summary Envia o logo impresso no cabeçalho dos documentos
 */
export const useMeControllerEnviarLogo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarLogo>>, TError,{data: MeControllerEnviarLogoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerEnviarLogo>>,
        TError,
        {data: MeControllerEnviarLogoBody},
        TContext
      > => {
      return useMutation(getMeControllerEnviarLogoMutationOptions(options), queryClient);
    }
    export const getMeControllerRemoverLogoUrl = () => {




  return `/v1/me/logo`
}

/**
 * @summary Remove o logo
 */
export const meControllerRemoverLogo = async ( options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {

  return httpClient<MeResponse>(getMeControllerRemoverLogoUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMeControllerRemoverLogoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerRemoverLogo>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerRemoverLogo>>, TError,void, TContext> => {

const mutationKey = ['meControllerRemoverLogo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerRemoverLogo>>, void> = () => {


          return  meControllerRemoverLogo(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerRemoverLogoMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerRemoverLogo>>>

    export type MeControllerRemoverLogoMutationError = unknown

    /**
 * @summary Remove o logo
 */
export const useMeControllerRemoverLogo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerRemoverLogo>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerRemoverLogo>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMeControllerRemoverLogoMutationOptions(options), queryClient);
    }
    export const getMeControllerEnviarFotoUrl = () => {




  return `/v1/me/foto`
}

/**
 * @summary Envia a foto de perfil. Exige proporção 1:1 (ex.: 400×400).
 */
export const meControllerEnviarFoto = async (meControllerEnviarFotoBody: MeControllerEnviarFotoBody, options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, meControllerEnviarFotoBody.arquivo);

  return httpClient<MeResponse>(getMeControllerEnviarFotoUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getMeControllerEnviarFotoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarFoto>>, TError,{data: MeControllerEnviarFotoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarFoto>>, TError,{data: MeControllerEnviarFotoBody}, TContext> => {

const mutationKey = ['meControllerEnviarFoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerEnviarFoto>>, {data: MeControllerEnviarFotoBody}> = (props) => {
          const {data} = props ?? {};

          return  meControllerEnviarFoto(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerEnviarFotoMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerEnviarFoto>>>
    export type MeControllerEnviarFotoMutationBody = MeControllerEnviarFotoBody
    export type MeControllerEnviarFotoMutationError = ErroResponse

    /**
 * @summary Envia a foto de perfil. Exige proporção 1:1 (ex.: 400×400).
 */
export const useMeControllerEnviarFoto = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarFoto>>, TError,{data: MeControllerEnviarFotoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerEnviarFoto>>,
        TError,
        {data: MeControllerEnviarFotoBody},
        TContext
      > => {
      return useMutation(getMeControllerEnviarFotoMutationOptions(options), queryClient);
    }
    export const getMeControllerRemoverFotoUrl = () => {




  return `/v1/me/foto`
}

/**
 * @summary Remove a foto de perfil
 */
export const meControllerRemoverFoto = async ( options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {

  return httpClient<MeResponse>(getMeControllerRemoverFotoUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMeControllerRemoverFotoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerRemoverFoto>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerRemoverFoto>>, TError,void, TContext> => {

const mutationKey = ['meControllerRemoverFoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerRemoverFoto>>, void> = () => {


          return  meControllerRemoverFoto(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerRemoverFotoMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerRemoverFoto>>>

    export type MeControllerRemoverFotoMutationError = unknown

    /**
 * @summary Remove a foto de perfil
 */
export const useMeControllerRemoverFoto = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerRemoverFoto>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerRemoverFoto>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMeControllerRemoverFotoMutationOptions(options), queryClient);
    }
    export const getMeControllerDefinirAssinaturaUrl = () => {




  return `/v1/me/assinatura`
}

/**
 * @summary Define assinatura sem arquivo (nenhuma ou digitada)
 */
export const meControllerDefinirAssinatura = async (definirAssinaturaDto: DefinirAssinaturaDto, options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {

  return httpClient<MeResponse>(getMeControllerDefinirAssinaturaUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirAssinaturaDto)
  }
);}





export const getMeControllerDefinirAssinaturaMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerDefinirAssinatura>>, TError,{data: DefinirAssinaturaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerDefinirAssinatura>>, TError,{data: DefinirAssinaturaDto}, TContext> => {

const mutationKey = ['meControllerDefinirAssinatura'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerDefinirAssinatura>>, {data: DefinirAssinaturaDto}> = (props) => {
          const {data} = props ?? {};

          return  meControllerDefinirAssinatura(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerDefinirAssinaturaMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerDefinirAssinatura>>>
    export type MeControllerDefinirAssinaturaMutationBody = DefinirAssinaturaDto
    export type MeControllerDefinirAssinaturaMutationError = ErroResponse

    /**
 * @summary Define assinatura sem arquivo (nenhuma ou digitada)
 */
export const useMeControllerDefinirAssinatura = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerDefinirAssinatura>>, TError,{data: DefinirAssinaturaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerDefinirAssinatura>>,
        TError,
        {data: DefinirAssinaturaDto},
        TContext
      > => {
      return useMutation(getMeControllerDefinirAssinaturaMutationOptions(options), queryClient);
    }
    export const getMeControllerRemoverAssinaturaUrl = () => {




  return `/v1/me/assinatura`
}

/**
 * @summary Remove a assinatura — o documento volta a sair com linha em branco
 */
export const meControllerRemoverAssinatura = async ( options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {

  return httpClient<MeResponse>(getMeControllerRemoverAssinaturaUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMeControllerRemoverAssinaturaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerRemoverAssinatura>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerRemoverAssinatura>>, TError,void, TContext> => {

const mutationKey = ['meControllerRemoverAssinatura'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerRemoverAssinatura>>, void> = () => {


          return  meControllerRemoverAssinatura(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerRemoverAssinaturaMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerRemoverAssinatura>>>

    export type MeControllerRemoverAssinaturaMutationError = unknown

    /**
 * @summary Remove a assinatura — o documento volta a sair com linha em branco
 */
export const useMeControllerRemoverAssinatura = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerRemoverAssinatura>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerRemoverAssinatura>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMeControllerRemoverAssinaturaMutationOptions(options), queryClient);
    }
    export const getMeControllerEnviarAssinaturaImagemUrl = () => {




  return `/v1/me/assinatura/imagem`
}

/**
 * @summary Envia a assinatura como imagem (rubrica desenhada ou digitalizada)
 */
export const meControllerEnviarAssinaturaImagem = async (meControllerEnviarAssinaturaImagemBody: MeControllerEnviarAssinaturaImagemBody, options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, meControllerEnviarAssinaturaImagemBody.arquivo);
formData.append(`tipo`, meControllerEnviarAssinaturaImagemBody.tipo);

  return httpClient<MeResponse>(getMeControllerEnviarAssinaturaImagemUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getMeControllerEnviarAssinaturaImagemMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarAssinaturaImagem>>, TError,{data: MeControllerEnviarAssinaturaImagemBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarAssinaturaImagem>>, TError,{data: MeControllerEnviarAssinaturaImagemBody}, TContext> => {

const mutationKey = ['meControllerEnviarAssinaturaImagem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerEnviarAssinaturaImagem>>, {data: MeControllerEnviarAssinaturaImagemBody}> = (props) => {
          const {data} = props ?? {};

          return  meControllerEnviarAssinaturaImagem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerEnviarAssinaturaImagemMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerEnviarAssinaturaImagem>>>
    export type MeControllerEnviarAssinaturaImagemMutationBody = MeControllerEnviarAssinaturaImagemBody
    export type MeControllerEnviarAssinaturaImagemMutationError = ErroResponse

    /**
 * @summary Envia a assinatura como imagem (rubrica desenhada ou digitalizada)
 */
export const useMeControllerEnviarAssinaturaImagem = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarAssinaturaImagem>>, TError,{data: MeControllerEnviarAssinaturaImagemBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerEnviarAssinaturaImagem>>,
        TError,
        {data: MeControllerEnviarAssinaturaImagemBody},
        TContext
      > => {
      return useMutation(getMeControllerEnviarAssinaturaImagemMutationOptions(options), queryClient);
    }
    export const getMeControllerEnviarCertificadoUrl = () => {




  return `/v1/me/assinatura/certificado`
}

/**
 * @deprecated
 * @summary Legado: envia só a parte pública do certificado (.cer, .crt, .pem). Não assina o PDF — use certificado-a1.
 */
export const meControllerEnviarCertificado = async (meControllerEnviarCertificadoBody: MeControllerEnviarCertificadoBody, options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, meControllerEnviarCertificadoBody.arquivo);

  return httpClient<MeResponse>(getMeControllerEnviarCertificadoUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getMeControllerEnviarCertificadoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarCertificado>>, TError,{data: MeControllerEnviarCertificadoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarCertificado>>, TError,{data: MeControllerEnviarCertificadoBody}, TContext> => {

const mutationKey = ['meControllerEnviarCertificado'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerEnviarCertificado>>, {data: MeControllerEnviarCertificadoBody}> = (props) => {
          const {data} = props ?? {};

          return  meControllerEnviarCertificado(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerEnviarCertificadoMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerEnviarCertificado>>>
    export type MeControllerEnviarCertificadoMutationBody = MeControllerEnviarCertificadoBody
    export type MeControllerEnviarCertificadoMutationError = ErroResponse

    /**
 * @deprecated
 * @summary Legado: envia só a parte pública do certificado (.cer, .crt, .pem). Não assina o PDF — use certificado-a1.
 */
export const useMeControllerEnviarCertificado = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarCertificado>>, TError,{data: MeControllerEnviarCertificadoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerEnviarCertificado>>,
        TError,
        {data: MeControllerEnviarCertificadoBody},
        TContext
      > => {
      return useMutation(getMeControllerEnviarCertificadoMutationOptions(options), queryClient);
    }
    export const getMeControllerEnviarCertificadoA1Url = () => {




  return `/v1/me/assinatura/certificado-a1`
}

/**
 * @summary Envia o certificado A1 (.pfx/.p12) que assina os PDFs digitalmente
 */
export const meControllerEnviarCertificadoA1 = async (meControllerEnviarCertificadoA1Body: MeControllerEnviarCertificadoA1Body, options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, meControllerEnviarCertificadoA1Body.arquivo);
formData.append(`senha`, meControllerEnviarCertificadoA1Body.senha);
if(meControllerEnviarCertificadoA1Body.guardarSenha !== undefined) {
 formData.append(`guardarSenha`, meControllerEnviarCertificadoA1Body.guardarSenha);
 }

  return httpClient<MeResponse>(getMeControllerEnviarCertificadoA1Url(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getMeControllerEnviarCertificadoA1MutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarCertificadoA1>>, TError,{data: MeControllerEnviarCertificadoA1Body}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarCertificadoA1>>, TError,{data: MeControllerEnviarCertificadoA1Body}, TContext> => {

const mutationKey = ['meControllerEnviarCertificadoA1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerEnviarCertificadoA1>>, {data: MeControllerEnviarCertificadoA1Body}> = (props) => {
          const {data} = props ?? {};

          return  meControllerEnviarCertificadoA1(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerEnviarCertificadoA1MutationResult = NonNullable<Awaited<ReturnType<typeof meControllerEnviarCertificadoA1>>>
    export type MeControllerEnviarCertificadoA1MutationBody = MeControllerEnviarCertificadoA1Body
    export type MeControllerEnviarCertificadoA1MutationError = ErroResponse

    /**
 * @summary Envia o certificado A1 (.pfx/.p12) que assina os PDFs digitalmente
 */
export const useMeControllerEnviarCertificadoA1 = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEnviarCertificadoA1>>, TError,{data: MeControllerEnviarCertificadoA1Body}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerEnviarCertificadoA1>>,
        TError,
        {data: MeControllerEnviarCertificadoA1Body},
        TContext
      > => {
      return useMutation(getMeControllerEnviarCertificadoA1MutationOptions(options), queryClient);
    }
    export const getMeControllerIniciarSafeIdUrl = () => {




  return `/v1/me/assinatura/safeid`
}

/**
 * @summary Pede ao titular a autorização de uso do certificado SafeID
 */
export const meControllerIniciarSafeId = async (iniciarSafeIdDto: IniciarSafeIdDto, options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {

  return httpClient<MeResponse>(getMeControllerIniciarSafeIdUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(iniciarSafeIdDto)
  }
);}





export const getMeControllerIniciarSafeIdMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerIniciarSafeId>>, TError,{data: IniciarSafeIdDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerIniciarSafeId>>, TError,{data: IniciarSafeIdDto}, TContext> => {

const mutationKey = ['meControllerIniciarSafeId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerIniciarSafeId>>, {data: IniciarSafeIdDto}> = (props) => {
          const {data} = props ?? {};

          return  meControllerIniciarSafeId(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerIniciarSafeIdMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerIniciarSafeId>>>
    export type MeControllerIniciarSafeIdMutationBody = IniciarSafeIdDto
    export type MeControllerIniciarSafeIdMutationError = ErroResponse

    /**
 * @summary Pede ao titular a autorização de uso do certificado SafeID
 */
export const useMeControllerIniciarSafeId = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerIniciarSafeId>>, TError,{data: IniciarSafeIdDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerIniciarSafeId>>,
        TError,
        {data: IniciarSafeIdDto},
        TContext
      > => {
      return useMutation(getMeControllerIniciarSafeIdMutationOptions(options), queryClient);
    }
    export const getMeControllerConcluirSafeIdUrl = () => {




  return `/v1/me/assinatura/safeid/concluir`
}

/**
 * @summary Conclui o cadastro do SafeID com a senha do certificado
 */
export const meControllerConcluirSafeId = async (concluirSafeIdDto: ConcluirSafeIdDto, options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {

  return httpClient<MeResponse>(getMeControllerConcluirSafeIdUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(concluirSafeIdDto)
  }
);}





export const getMeControllerConcluirSafeIdMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerConcluirSafeId>>, TError,{data: ConcluirSafeIdDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerConcluirSafeId>>, TError,{data: ConcluirSafeIdDto}, TContext> => {

const mutationKey = ['meControllerConcluirSafeId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerConcluirSafeId>>, {data: ConcluirSafeIdDto}> = (props) => {
          const {data} = props ?? {};

          return  meControllerConcluirSafeId(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerConcluirSafeIdMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerConcluirSafeId>>>
    export type MeControllerConcluirSafeIdMutationBody = ConcluirSafeIdDto
    export type MeControllerConcluirSafeIdMutationError = ErroResponse

    /**
 * @summary Conclui o cadastro do SafeID com a senha do certificado
 */
export const useMeControllerConcluirSafeId = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerConcluirSafeId>>, TError,{data: ConcluirSafeIdDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerConcluirSafeId>>,
        TError,
        {data: ConcluirSafeIdDto},
        TContext
      > => {
      return useMutation(getMeControllerConcluirSafeIdMutationOptions(options), queryClient);
    }
    export const getMeControllerIniciarSerproIdUrl = () => {




  return `/v1/me/assinatura/serproid`
}

/**
 * @summary Prepara a autorização do certificado SerproID e devolve a URL de aprovação
 */
export const meControllerIniciarSerproId = async (iniciarSerproIdDto: IniciarSerproIdDto, options?: Parameters<typeof httpClient>[1]): Promise<IniciarSerproIdResponse> => {

  return httpClient<IniciarSerproIdResponse>(getMeControllerIniciarSerproIdUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(iniciarSerproIdDto)
  }
);}





export const getMeControllerIniciarSerproIdMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerIniciarSerproId>>, TError,{data: IniciarSerproIdDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerIniciarSerproId>>, TError,{data: IniciarSerproIdDto}, TContext> => {

const mutationKey = ['meControllerIniciarSerproId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerIniciarSerproId>>, {data: IniciarSerproIdDto}> = (props) => {
          const {data} = props ?? {};

          return  meControllerIniciarSerproId(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerIniciarSerproIdMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerIniciarSerproId>>>
    export type MeControllerIniciarSerproIdMutationBody = IniciarSerproIdDto
    export type MeControllerIniciarSerproIdMutationError = ErroResponse

    /**
 * @summary Prepara a autorização do certificado SerproID e devolve a URL de aprovação
 */
export const useMeControllerIniciarSerproId = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerIniciarSerproId>>, TError,{data: IniciarSerproIdDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerIniciarSerproId>>,
        TError,
        {data: IniciarSerproIdDto},
        TContext
      > => {
      return useMutation(getMeControllerIniciarSerproIdMutationOptions(options), queryClient);
    }
    export const getMeControllerConcluirSerproIdUrl = () => {




  return `/v1/me/assinatura/serproid/concluir`
}

/**
 * @summary Conclui o cadastro do SerproID com a volta da tela de aprovação do Serpro
 */
export const meControllerConcluirSerproId = async (concluirSerproIdDto: ConcluirSerproIdDto, options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {

  return httpClient<MeResponse>(getMeControllerConcluirSerproIdUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(concluirSerproIdDto)
  }
);}





export const getMeControllerConcluirSerproIdMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerConcluirSerproId>>, TError,{data: ConcluirSerproIdDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerConcluirSerproId>>, TError,{data: ConcluirSerproIdDto}, TContext> => {

const mutationKey = ['meControllerConcluirSerproId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerConcluirSerproId>>, {data: ConcluirSerproIdDto}> = (props) => {
          const {data} = props ?? {};

          return  meControllerConcluirSerproId(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerConcluirSerproIdMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerConcluirSerproId>>>
    export type MeControllerConcluirSerproIdMutationBody = ConcluirSerproIdDto
    export type MeControllerConcluirSerproIdMutationError = ErroResponse

    /**
 * @summary Conclui o cadastro do SerproID com a volta da tela de aprovação do Serpro
 */
export const useMeControllerConcluirSerproId = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerConcluirSerproId>>, TError,{data: ConcluirSerproIdDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerConcluirSerproId>>,
        TError,
        {data: ConcluirSerproIdDto},
        TContext
      > => {
      return useMutation(getMeControllerConcluirSerproIdMutationOptions(options), queryClient);
    }
    export const getMeControllerGuardarSenhaDoCertificadoUrl = () => {




  return `/v1/me/assinatura/senha`
}

/**
 * @summary Guarda a senha do certificado — as assinaturas deixam de pedi-la
 */
export const meControllerGuardarSenhaDoCertificado = async (senhaDoCertificadoDto: SenhaDoCertificadoDto, options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {

  return httpClient<MeResponse>(getMeControllerGuardarSenhaDoCertificadoUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(senhaDoCertificadoDto)
  }
);}





export const getMeControllerGuardarSenhaDoCertificadoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerGuardarSenhaDoCertificado>>, TError,{data: SenhaDoCertificadoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerGuardarSenhaDoCertificado>>, TError,{data: SenhaDoCertificadoDto}, TContext> => {

const mutationKey = ['meControllerGuardarSenhaDoCertificado'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerGuardarSenhaDoCertificado>>, {data: SenhaDoCertificadoDto}> = (props) => {
          const {data} = props ?? {};

          return  meControllerGuardarSenhaDoCertificado(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerGuardarSenhaDoCertificadoMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerGuardarSenhaDoCertificado>>>
    export type MeControllerGuardarSenhaDoCertificadoMutationBody = SenhaDoCertificadoDto
    export type MeControllerGuardarSenhaDoCertificadoMutationError = ErroResponse

    /**
 * @summary Guarda a senha do certificado — as assinaturas deixam de pedi-la
 */
export const useMeControllerGuardarSenhaDoCertificado = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerGuardarSenhaDoCertificado>>, TError,{data: SenhaDoCertificadoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerGuardarSenhaDoCertificado>>,
        TError,
        {data: SenhaDoCertificadoDto},
        TContext
      > => {
      return useMutation(getMeControllerGuardarSenhaDoCertificadoMutationOptions(options), queryClient);
    }
    export const getMeControllerEsquecerSenhaDoCertificadoUrl = () => {




  return `/v1/me/assinatura/senha`
}

/**
 * @summary Esquece a senha do certificado — cada assinatura passa a pedi-la
 */
export const meControllerEsquecerSenhaDoCertificado = async ( options?: Parameters<typeof httpClient>[1]): Promise<MeResponse> => {

  return httpClient<MeResponse>(getMeControllerEsquecerSenhaDoCertificadoUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMeControllerEsquecerSenhaDoCertificadoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEsquecerSenhaDoCertificado>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerEsquecerSenhaDoCertificado>>, TError,void, TContext> => {

const mutationKey = ['meControllerEsquecerSenhaDoCertificado'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerEsquecerSenhaDoCertificado>>, void> = () => {


          return  meControllerEsquecerSenhaDoCertificado(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerEsquecerSenhaDoCertificadoMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerEsquecerSenhaDoCertificado>>>

    export type MeControllerEsquecerSenhaDoCertificadoMutationError = ErroResponse

    /**
 * @summary Esquece a senha do certificado — cada assinatura passa a pedi-la
 */
export const useMeControllerEsquecerSenhaDoCertificado = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEsquecerSenhaDoCertificado>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerEsquecerSenhaDoCertificado>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMeControllerEsquecerSenhaDoCertificadoMutationOptions(options), queryClient);
    }
    export const getMeControllerRegistrarHeartbeatUrl = () => {




  return `/v1/me/atividade/heartbeat`
}

/**
 * @summary Heartbeat de atividade — chamado periodicamente com o app em foco
 */
export const meControllerRegistrarHeartbeat = async ( options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getMeControllerRegistrarHeartbeatUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMeControllerRegistrarHeartbeatMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerRegistrarHeartbeat>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerRegistrarHeartbeat>>, TError,void, TContext> => {

const mutationKey = ['meControllerRegistrarHeartbeat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerRegistrarHeartbeat>>, void> = () => {


          return  meControllerRegistrarHeartbeat(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerRegistrarHeartbeatMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerRegistrarHeartbeat>>>

    export type MeControllerRegistrarHeartbeatMutationError = unknown

    /**
 * @summary Heartbeat de atividade — chamado periodicamente com o app em foco
 */
export const useMeControllerRegistrarHeartbeat = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerRegistrarHeartbeat>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerRegistrarHeartbeat>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMeControllerRegistrarHeartbeatMutationOptions(options), queryClient);
    }
    export const getMeControllerRegistrarTokenPushUrl = () => {




  return `/v1/me/token-push`
}

/**
 * @summary Registra o token de push (Expo) do device atual
 */
export const meControllerRegistrarTokenPush = async (registrarTokenPushDto: RegistrarTokenPushDto, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getMeControllerRegistrarTokenPushUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registrarTokenPushDto)
  }
);}





export const getMeControllerRegistrarTokenPushMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerRegistrarTokenPush>>, TError,{data: RegistrarTokenPushDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerRegistrarTokenPush>>, TError,{data: RegistrarTokenPushDto}, TContext> => {

const mutationKey = ['meControllerRegistrarTokenPush'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerRegistrarTokenPush>>, {data: RegistrarTokenPushDto}> = (props) => {
          const {data} = props ?? {};

          return  meControllerRegistrarTokenPush(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerRegistrarTokenPushMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerRegistrarTokenPush>>>
    export type MeControllerRegistrarTokenPushMutationBody = RegistrarTokenPushDto
    export type MeControllerRegistrarTokenPushMutationError = unknown

    /**
 * @summary Registra o token de push (Expo) do device atual
 */
export const useMeControllerRegistrarTokenPush = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerRegistrarTokenPush>>, TError,{data: RegistrarTokenPushDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerRegistrarTokenPush>>,
        TError,
        {data: RegistrarTokenPushDto},
        TContext
      > => {
      return useMutation(getMeControllerRegistrarTokenPushMutationOptions(options), queryClient);
    }
    export const getMeControllerRemoverTokenPushUrl = () => {




  return `/v1/me/token-push`
}

/**
 * @summary Remove o token de push (Expo) do device atual — chamado no logout
 */
export const meControllerRemoverTokenPush = async (removerTokenPushDto: RemoverTokenPushDto, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getMeControllerRemoverTokenPushUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(removerTokenPushDto)
  }
);}





export const getMeControllerRemoverTokenPushMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerRemoverTokenPush>>, TError,{data: RemoverTokenPushDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerRemoverTokenPush>>, TError,{data: RemoverTokenPushDto}, TContext> => {

const mutationKey = ['meControllerRemoverTokenPush'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerRemoverTokenPush>>, {data: RemoverTokenPushDto}> = (props) => {
          const {data} = props ?? {};

          return  meControllerRemoverTokenPush(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerRemoverTokenPushMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerRemoverTokenPush>>>
    export type MeControllerRemoverTokenPushMutationBody = RemoverTokenPushDto
    export type MeControllerRemoverTokenPushMutationError = unknown

    /**
 * @summary Remove o token de push (Expo) do device atual — chamado no logout
 */
export const useMeControllerRemoverTokenPush = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerRemoverTokenPush>>, TError,{data: RemoverTokenPushDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerRemoverTokenPush>>,
        TError,
        {data: RemoverTokenPushDto},
        TContext
      > => {
      return useMutation(getMeControllerRemoverTokenPushMutationOptions(options), queryClient);
    }
    export const getMeControllerListarNotificacoesUrl = (params?: MeControllerListarNotificacoesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/me/notificacoes?${stringifiedParams}` : `/v1/me/notificacoes`
}

/**
 * @summary Lista o histórico de notificações do perfil da sessão
 */
export const meControllerListarNotificacoes = async (params?: MeControllerListarNotificacoesParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeNotificacoesResponse> => {

  return httpClient<PaginaDeNotificacoesResponse>(getMeControllerListarNotificacoesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeControllerListarNotificacoesQueryKey = (params?: MeControllerListarNotificacoesParams,) => {
    return [
    `/v1/me/notificacoes`, ...(params ? [params] : [])
    ] as const;
    }


export const getMeControllerListarNotificacoesQueryOptions = <TData = Awaited<ReturnType<typeof meControllerListarNotificacoes>>, TError = unknown>(params?: MeControllerListarNotificacoesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerListarNotificacoes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeControllerListarNotificacoesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerListarNotificacoes>>> = ({ signal }) => meControllerListarNotificacoes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerListarNotificacoes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeControllerListarNotificacoesQueryResult = NonNullable<Awaited<ReturnType<typeof meControllerListarNotificacoes>>>
export type MeControllerListarNotificacoesQueryError = unknown


export function useMeControllerListarNotificacoes<TData = Awaited<ReturnType<typeof meControllerListarNotificacoes>>, TError = unknown>(
 params: undefined |  MeControllerListarNotificacoesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerListarNotificacoes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerListarNotificacoes>>,
          TError,
          Awaited<ReturnType<typeof meControllerListarNotificacoes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeControllerListarNotificacoes<TData = Awaited<ReturnType<typeof meControllerListarNotificacoes>>, TError = unknown>(
 params?: MeControllerListarNotificacoesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerListarNotificacoes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerListarNotificacoes>>,
          TError,
          Awaited<ReturnType<typeof meControllerListarNotificacoes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeControllerListarNotificacoes<TData = Awaited<ReturnType<typeof meControllerListarNotificacoes>>, TError = unknown>(
 params?: MeControllerListarNotificacoesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerListarNotificacoes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista o histórico de notificações do perfil da sessão
 */

export function useMeControllerListarNotificacoes<TData = Awaited<ReturnType<typeof meControllerListarNotificacoes>>, TError = unknown>(
 params?: MeControllerListarNotificacoesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerListarNotificacoes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeControllerListarNotificacoesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMeControllerMarcarNotificacaoComoLidaUrl = (id: string,) => {




  return `/v1/me/notificacoes/${id}/lida`
}

/**
 * @summary Marca uma notificação como lida
 */
export const meControllerMarcarNotificacaoComoLida = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getMeControllerMarcarNotificacaoComoLidaUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMeControllerMarcarNotificacaoComoLidaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerMarcarNotificacaoComoLida>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerMarcarNotificacaoComoLida>>, TError,{id: string}, TContext> => {

const mutationKey = ['meControllerMarcarNotificacaoComoLida'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerMarcarNotificacaoComoLida>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  meControllerMarcarNotificacaoComoLida(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerMarcarNotificacaoComoLidaMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerMarcarNotificacaoComoLida>>>

    export type MeControllerMarcarNotificacaoComoLidaMutationError = unknown

    /**
 * @summary Marca uma notificação como lida
 */
export const useMeControllerMarcarNotificacaoComoLida = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerMarcarNotificacaoComoLida>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerMarcarNotificacaoComoLida>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getMeControllerMarcarNotificacaoComoLidaMutationOptions(options), queryClient);
    }
    export const getMeControllerMarcarTodasAsNotificacoesComoLidasUrl = () => {




  return `/v1/me/notificacoes/lidas`
}

/**
 * @summary Marca TODAS as notificações do perfil como lidas
 */
export const meControllerMarcarTodasAsNotificacoesComoLidas = async ( options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getMeControllerMarcarTodasAsNotificacoesComoLidasUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMeControllerMarcarTodasAsNotificacoesComoLidasMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerMarcarTodasAsNotificacoesComoLidas>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerMarcarTodasAsNotificacoesComoLidas>>, TError,void, TContext> => {

const mutationKey = ['meControllerMarcarTodasAsNotificacoesComoLidas'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerMarcarTodasAsNotificacoesComoLidas>>, void> = () => {


          return  meControllerMarcarTodasAsNotificacoesComoLidas(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerMarcarTodasAsNotificacoesComoLidasMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerMarcarTodasAsNotificacoesComoLidas>>>

    export type MeControllerMarcarTodasAsNotificacoesComoLidasMutationError = unknown

    /**
 * @summary Marca TODAS as notificações do perfil como lidas
 */
export const useMeControllerMarcarTodasAsNotificacoesComoLidas = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerMarcarTodasAsNotificacoesComoLidas>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerMarcarTodasAsNotificacoesComoLidas>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMeControllerMarcarTodasAsNotificacoesComoLidasMutationOptions(options), queryClient);
    }
